<script>
  import { mapState } from 'vuex'
  import { itemMixin, animationMixin } from './mixin'
  import NavigationItemArrow from './NavigationItemArrow'
  import NavigationItemBadge from './NavigationItemBadge'
  import NavigationItemChild from './NavigationItemChild'
  import NavigationItemIcon from './NavigationItemIcon'

  export default {
    name: 'navigation-item',

    components: {
      NavigationItemArrow,
      NavigationItemBadge,
      NavigationItemChild,
      NavigationItemIcon
    },

    mixins: [itemMixin, animationMixin],

    props: {
      item: {
        type: Object,
        required: true
      },
      firstItem: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState('navigation', {
        isCollapsed: state => state.isCollapsed
      })
    },

    methods: {
      mouseEnter (event) {
        if (this.isCollapsed && this.firstItem) {
          this.$parent.$emit('mouseEnterItem', {
            item: this.item,
            pos: event.currentTarget.getBoundingClientRect().top - this.$parent.$el.getBoundingClientRect().top,
            height: this.$el.offsetHeight
          })
        }
      }
    }
  }
</script>

<template>
  <div class="menu-item"
       :class="[{'open-item' : show}, {'active-item' : active}, {'parent-active-item' : childActive}]"
       @mouseenter="mouseEnter($event)">
    <template>
      <router-link class="item-link"
                   :to="item.href ? item.href : ''"
                   :disabled="item.disabled"
                   :event="item.disabled ? '' : 'click'" @click.native="clickEvent">
        <navigation-item-icon :item="item"/>

        <template v-if="!isCollapsed">
          <navigation-item-badge :item="item"/>
          <span class="item-title">
            {{ item.title }}
          </span>
          <navigation-item-arrow :item="item" :is-open="show"/>
        </template>
      </router-link>
    </template>

    <template v-if="item.children">
      <template v-if="!isCollapsed">
        <transition name="expand" @enter="expandEnter" @afterEnter="expandAfterEnter" @beforeLeave="expandBeforeLeave">
          <div v-if="show" class="menu-dropdown">
            <div class="menu">
              <navigation-item-child v-for="(child, index) in item.children" :key="index" :item="child"/>
            </div>
          </div>
        </transition>
      </template>
    </template>
  </div>
</template>
